<template>
 
    <div class="text1">
       编辑资料
       <div class="line"></div>
       <form :model="inform" class="flex-column-align" autocomplete="off" style="width: 100%;margin:0 auto;padding: 0 10%;">
            <p class="p1">邮箱</p>
			<input v-model="inform.email" type="text" placeholder="请输入邮箱" class="inputacc">
            <p class="p1">联系电话</p>
			<input v-model="inform.phone" type="text" placeholder="请输入电话" class="inputacc">
        </form>
        <el-button class="sure" @click="surechange">确认修改</el-button>

    </div>
   


</template>
<script>

export default {
      props:{
        inform: {
				type: Object,
				default: () => {
					return {}
				}
			},
    },
    components: {
      
    },

    data() {
      return {
        

      }
    },
    methods:{
        surechange(){
        const data = this.inform;
        console.log(data,'dddata')
        this.$emit("custom-info", data);
      }
    }
  }
</script>
<style scoped>
.p1{
    text-align: left !important;
  align-self: flex-start;

font-size: 20px;
font-weight: 500;
letter-spacing: 0px;
line-height: 28.96px;
color: rgba(67, 67, 67, 1);
text-align: left;
margin-top: 26px;
}
.text1{
width: 100%;
font-size: 35px;
font-weight: 500;
letter-spacing: 0px;
line-height: 50.68px;
color: rgba(51, 51, 51, 1);
text-align: center;
}
.line{
width: 60px;
height: 8px;
opacity: 1;
border-radius: 50px;
background: rgba(69, 131, 250, 1);

text-align: center;
margin:0 auto;
}
.inputacc{

padding-left: 20px;
width: 100%;
height: 45px;
opacity: 1;
border-radius: 10px;
background: rgba(255, 255, 255, 1);

border: 1px solid rgba(39, 154, 255, 1);



}

.sure{


width: 362px;
height: 55px;
opacity: 1;
border-radius: 27.5px;
background: linear-gradient(182.83deg, rgba(75, 123, 248, 1) 0%, rgba(57, 145, 255, 1) 100%);


font-size: 30px;
font-weight: 500;
letter-spacing: 0px;
line-height: 30px;
color: rgba(255, 255, 255, 1);
text-align: center;
margin-top: 53px;

}

</style>